import { ErrorHero } from './ErrorHero';

export const SomethingWentWrongHero = () => (
  <ErrorHero
    title="Something went wrong."
    subtitle={'Sorry, an error has occurred; try reloading the\u00a0page.'}
  />
);
